import React from 'react';
import { Check, X } from 'lucide-react';
import { Reveal } from '../Reveal';
import { bloquesComparativos } from '../../data/content';
import type { ComparisonBlock } from '../../types/content';
function Bloque({
  bloque
}: {
  bloque: ComparisonBlock;
}) {
  return <article className="overflow-hidden rounded-2xl border border-black/5 bg-white shadow-soft" data-id="element-208" data-mp="zpanhpp77qx1">
      <div className="h-1 w-full bg-gradient-to-r from-bordo via-dorado to-verde" aria-hidden="true" data-id="element-209" data-mp="uuwws0lhe7yp" />
      <div className="p-6 sm:p-9" data-id="element-210" data-mp="13t8knuuyqrng">
        <h3 className="font-display text-2xl font-bold text-bordo sm:text-3xl" style={{
        textAlign: "center"
      }} data-id="element-211" data-mp="13u0g95ok8pdq">{bloque.titulo}</h3>
        <p className="mt-3 text-sm italic text-tintasuave sm:text-base" style={{
        fontSize: "12px",
        textAlign: "center"
      }} data-id="element-212" data-mp="1ihlfupm886gw">{bloque.frase}</p>

        <div className="mt-7 overflow-hidden rounded-xl border border-black/5" data-id="element-213" data-mp="1rijq3pn9da7x">
          <div className="grid grid-cols-2" data-id="element-214" data-mp="1rggp6akkhwof">
            <p className="bg-grisclaro px-4 py-3 text-[11px] font-bold uppercase tracking-wide text-tintasuave sm:text-xs" data-id="element-215" data-mp="1ni98ffq3svd8">
              {bloque.columnaSin}
            </p>
            <p className="bg-verde/10 px-4 py-3 text-[11px] font-bold uppercase tracking-wide text-verde-dark sm:text-xs" data-id="element-216" data-mp="37sctk2x1w6mh">
              {bloque.columnaCon}
            </p>
          </div>
          {bloque.filas.map(fila => <div key={fila.sin} className="grid grid-cols-2 border-t border-black/5" data-id="element-217" data-mp="3hrtwickx46er">
              <div className="flex items-start gap-2 px-4 py-4" data-id="element-218" data-mp="3mqoq89kfbfdn">
                <X className="mt-0.5 h-4 w-4 shrink-0 text-bordo/60" aria-hidden="true" data-id="element-219" data-mp="3qrh1f8cuvuck" />
                <span className="text-xs leading-relaxed text-tintasuave sm:text-sm" data-id="element-220" data-mp="3qp49c2ddw3ls">{fila.sin}</span>
              </div>
              <div className="flex items-start gap-2 bg-verde/5 px-4 py-4" data-id="element-221" data-mp="4bmivaqix5eg">
                <Check className="mt-0.5 h-4 w-4 shrink-0 text-verde" aria-hidden="true" data-id="element-222" data-mp="4dqmrsofa4eq" />
                <span className="text-xs font-medium leading-relaxed text-tinta sm:text-sm" data-id="element-223" data-mp="98w7io639d18">{fila.con}</span>
              </div>
            </div>)}
        </div>
      </div>
    </article>;
}
export function Profundizacion() {
  return <section aria-labelledby="profundizacion-titulo" className="w-full bg-crema px-4 py-16 sm:px-6 sm:py-20" data-id="element-224" data-mp="3ft0q6ey3wy3a">
      <div className="mx-auto max-w-5xl" data-id="element-225" data-mp="3uiosnji0y2sl">
        <Reveal data-id="element-226" data-mp="3pqf70fnxzow4">
          <div className="text-center" data-id="element-227" data-mp="3ppvlyq2zwkdv">
            <h2 id="profundizacion-titulo" className="font-display text-3xl font-bold text-bordo sm:text-4xl" data-id="element-228" data-mp="3poue0uha0e0d">
              ¿Qué hace diferente a Profes de Telas Resuelto™?
            </h2>
            <p className="mx-auto mt-4 max-w-2xl text-base text-tintasuave sm:text-lg" data-id="element-229" data-mp="halpbxhvk7dh">
              No es una colección de ejercicios sueltos. Es un sistema para enseñar, organizarte y crecer.
            </p>
          </div>
        </Reveal>

        <div className="mt-12 grid gap-8" data-id="element-230" data-mp="2j302ykddypo3">
          {bloquesComparativos.map((bloque, index) => <Reveal key={bloque.titulo} delay={index * 0.05} data-id="element-231" data-mp="2e3x9zyaok9wh" data-mpi={index}>
              <Bloque bloque={bloque} data-id="element-232" data-mp="tl38invmhtg8" />
            </Reveal>)}
        </div>
      </div>
    </section>;
}